module.exports = __webpack_public_path__ + "img/adesao-concluida.93bbb938.svg";